import { useState, useEffect } from "react";
import { FileText, Download, ExternalLink, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL, API } from '@/lib/backendUrl';


const DOCS = [
  {
    slug: "deep-funding-grant",
    title: "Deep Funding Grant Proposal",
    subtitle: "SingularityNET Deep Funding Program",
    amount: "$75,000",
    color: "#10b981",
    bg: "linear-gradient(135deg, #022c22 0%, #064e3b 100%)",
  },
  {
    slug: "asi-partnership",
    title: "ASI Alliance Partnership Application",
    subtitle: "Artificial Superintelligence Alliance",
    amount: "Partnership",
    color: "#e8c547",
    bg: "linear-gradient(135deg, #0f0f23 0%, #1a1a3e 100%)",
  },
  {
    slug: "fetchai-accelerator",
    title: "Fetch.ai Accelerator Application",
    subtitle: "Fetch.ai Accelerator Program",
    amount: "Accelerator",
    color: "#3b82f6",
    bg: "linear-gradient(135deg, #0c1a3a 0%, #1e3a5f 100%)",
  },
];

export default function DocumentsPage() {
  const navigate = useNavigate();

  const openPdf = (slug) => {
    window.open(`${API}/api/docs/pdf/${slug}`, "_blank");
  };

  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", color: "#fff", padding: "40px 24px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <button
          data-testid="back-button"
          onClick={() => navigate(-1)}
          style={{
            display: "inline-flex", alignItems: "center", gap: 6,
            background: "none", border: "1px solid #333", color: "#aaa",
            padding: "8px 16px", borderRadius: 8, cursor: "pointer", marginBottom: 32,
            fontSize: 13,
          }}
        >
          <ArrowLeft size={16} /> Back
        </button>

        <h1 data-testid="documents-title" style={{ fontSize: 32, fontWeight: 800, marginBottom: 8, letterSpacing: -0.5 }}>
          Documents
        </h1>
        <p style={{ color: "#888", fontSize: 14, marginBottom: 40 }}>
          Grant proposals and partnership applications — click to open as PDF
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {DOCS.map((doc) => (
            <div
              key={doc.slug}
              data-testid={`doc-card-${doc.slug}`}
              onClick={() => openPdf(doc.slug)}
              style={{
                background: doc.bg,
                borderRadius: 14,
                padding: "28px 32px",
                cursor: "pointer",
                transition: "transform 0.15s, box-shadow 0.15s",
                border: `1px solid ${doc.color}22`,
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = `0 8px 32px ${doc.color}20`; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                  <div style={{
                    width: 48, height: 48, borderRadius: 12,
                    background: `${doc.color}20`, display: "flex",
                    alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    <FileText size={24} color={doc.color} />
                  </div>
                  <div>
                    <h2 style={{ fontSize: 18, fontWeight: 700, color: "#fff", margin: 0 }}>
                      {doc.title}
                    </h2>
                    <p style={{ fontSize: 13, color: "#aaa", margin: "4px 0 0" }}>
                      {doc.subtitle}
                    </p>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <span style={{
                    background: `${doc.color}20`, color: doc.color,
                    padding: "4px 12px", borderRadius: 20,
                    fontSize: 12, fontWeight: 600,
                  }}>
                    {doc.amount}
                  </span>
                  <ExternalLink size={18} color="#666" />
                </div>
              </div>

              <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
                <button
                  data-testid={`open-pdf-${doc.slug}`}
                  onClick={(e) => { e.stopPropagation(); openPdf(doc.slug); }}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 6,
                    background: doc.color, color: "#000",
                    border: "none", padding: "8px 18px", borderRadius: 8,
                    fontSize: 13, fontWeight: 600, cursor: "pointer",
                  }}
                >
                  <Download size={14} /> Open PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
